import Axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import config from '../config'
import { FONTS, SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'
import FacultyMemberModal from './GlobalModals/FacultyMemberModal'
import LoadIcon from './LoadIcon'

const SideNav = styled.div`
  text-align: center;
  #sidebar {
    display: ${(props) => (props.open ? 'block' : 'none')};
    width: 64%;
    max-width: 100vw;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    background-color: rgba(255, 255, 255, 0.9);
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    overflow-x: hidden;
    transition: 1000ms linear;

    .close {
      position: absolute;
      z-index: 55;
      background: transparent;
      border: none;
      outline: none;
      color: #002060;
      transition: 200ms;
      ${SIZES.rightBelowNoticeBar(9)}
      right: 20px;
      opacity: 1;
      padding: 8px;
      font-size: 16px;
      font-weight: 400;
      text-shadow: none;
    }
    svg {
      transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
    }
    .agenda {
      color: #002060;
      padding: 48px 32px;
    }
  }
  .image {
    height: 184px;
    width: 184px;
    transition: 100ms linear;
    background-position: center;
    background-size: cover;
    cursor: pointer;
    &:hover {
      border: 4px solid #ffad2c;
    }
  }
  h5, h6, p {
    font-family: ${FONTS.secondary};
  }
  h5.speaker-name {
    font-size: 15px;
    font-weight: 600;
    color: #0c6bae;
  }
  .speaker-position {
    margin: 0;
    font-size: 13px;
  }
  .speaker-title {
    font-size: 24px;
    color: #426fa8;
    font-weight: bold;
  }
  .speaker-category {
    font-weight: 600;
    color: #644ae4;
    text-transform: uppercase;
    margin: 0;
    font-size: 13px;
  }

  .divider {
    background: #ffad2c;
    height: 4.5px;
    margin: 32px 0;
  }

  ${SIZES.mobile} {
    #sidebar {
      width: 100vw;
    }
    .speaker-name {
      font-size: 18;
    }
  }
`

export default function FacultySide({ open, toggleSidebar }) {
  const startModal = useRef()
  const [loading, setLoading] = useState(false)
  const [members, setMembers] = useState([])
  const [showSpeaker, setShowSpeaker] = useState(false)
  const [selected, setSelected] = useState('')

  useEffect(() => {
    Axios.get(`${config.apiUrl}/api/faculty_members`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          setMembers(data.members)
          setLoading(false)
        }
      })
      .catch((err) => {
        setLoading(false)
        toast('Something went wrong. Please refresh your browser.')
        console.error('Error: ', err)
      })
  }, [])

  const handleShow = (id) => {
    Amplitude.clickFacultyModal(id)
    setShowSpeaker(true)
    setSelected(id)
  }

  return (
    <SideNav open={open}>
      <div id="sidebar">
        <button onClick={toggleSidebar} className="close">
          {open && (
            <>
              <small>Back</small>
              <svg width="49" height="49" viewBox="0 0 49 49">
                <defs>
                  <filter id="Ellipse_84" x="0" y="0" width="49" height="49" filterUnits="userSpaceOnUse">
                    <feOffset input="SourceAlpha" />
                    <feGaussianBlur stdDeviation="1.5" result="blur" />
                    <feFlood floodColor="#270d48" floodOpacity="0.533" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                  </filter>
                </defs>
                <g data-name="Group 24601" transform="translate(-4485.5 -1196.5)">
                  <g transform="matrix(1, 0, 0, 1, 4485.5, 1196.5)" filter="url(#Ellipse_84)">
                    <g transform="translate(4.5 4.5)" fill="#002060" stroke="#fff" strokeWidth="2">
                      <circle cx="20" cy="20" r="20" stroke="none" />
                      <circle cx="20" cy="20" r="19" fill="none" />
                    </g>
                  </g>
                  <g transform="translate(4515.301 1231.634) rotate(180)">
                    <path
                      d="M.353,11.119,10.107,20.3a1.258,1.258,0,0,0,1.7,0l1.138-1.071a1.088,1.088,0,0,0,0-1.6L5.22,10.317,12.95,3.005a1.088,1.088,0,0,0,0-1.6L11.811.332a1.258,1.258,0,0,0-1.7,0L.353,9.515A1.088,1.088,0,0,0,.353,11.119Z"
                      transform="translate(13.301 20.634) rotate(180)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </>
          )}
        </button>
        <div className="agenda h-100">
          {loading && <LoadIcon spinnerColor="#FFAD2C" />}
          <div className="container">
            <div ref={startModal}></div>
            <div>
              <p className="speaker-title">Speakers</p>
              <Row className="align-items-start">
                {members &&
                  members.map((speaker) => (
                    <Col sm={4} className="mb-3" key={`faculty-${speaker.id}`} onClick={() => handleShow(speaker.id)}>
                      <div className="image mb-2 img-fluid mx-auto rounded-circle" style={{ backgroundImage: `url(${speaker.image.url})` }}></div>
                      <p className="speaker-category">{speaker.honorific} :</p>
                      <h5 className="speaker-name">{speaker.fullName}</h5>
                      <p className="speaker-position" dangerouslySetInnerHTML={{ __html: speaker.title }} />
                    </Col>
                  ))}
              </Row>
            </div>
          </div>
        </div>
      </div>
      {showSpeaker && <FacultyMemberModal showSpeaker={showSpeaker} setShowSpeaker={setShowSpeaker} speakerId={selected} />}
    </SideNav>
  )
}
